import React, { useState } from 'react';
import usePaymentStore from '../../shared/store/use-payment-store';
import { showModalError } from '../../shared/components/modals/modal-error';
import { waitUserCancelCashoutsPending } from '../../shared/utils/cashouts';
import API from '../../../../utils/api';
import styles from './spei.module.css';
import iconoGeneraReferencia from '../../shared/assets/icono-genera-referencia.png';
import iconoBotonObtenerReferencia from '../../shared/assets/icono-boton-obtener-referencia.png';
import { SpeiWarnings } from '../../shared/components/spei-warnings';

const getPdfUrl = reference => {
  return process.env.NODE_ENV === 'production'
    ? `https://dashboard.openpay.mx/spei-pdf/myabfqccohuj4kszwr7y/${reference}`
    : `https://sandbox-dashboard.openpay.mx/spei-pdf/mqfki2pbqpbve54kabor/${reference}`;
};

export const SpeiOpenpay = () => {
  const { amount, isInvalidAmount } = usePaymentStore();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [order, setOrder] = useState(null);

  const processPayment = async () => {
    setIsSubmitting(true);
    try {
      const userCancell = await waitUserCancelCashoutsPending({
        buttonConfirm: 'Generar Referencia',
        buttonCancel: 'Cancelar',
      });

      if (userCancell) {
        setIsSubmitting(false);
        return;
      }

      const data = {
        amount: 'other',
        gateway: 'openpay',
        other_amount: amount,
        method: 'spei',
      };

      const response = await API.postDepositConvenience(data);

      if (response?.data?.success) {
        let pdfUrl = getPdfUrl(response.data.response.id);
        setOrder({ ...response.data.response, pdfUrl });
      } else {
        showModalError({ errorMessage: response.data.error });
      }
    } catch (error) {
      showModalError({ errorMessage: 'Ha ocurrido un error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      {!order && (
        <div className={styles.container}>
          {/* Header con icono y título */}
          <div className={styles.header}>
            <div className={styles.headerIcon}>
              <img src={iconoGeneraReferencia} alt="Icono generar referencia" />
            </div>
            <h2 className={styles.headerTitle}>
              Presiona sobre el botón para generar la referencia{' '}
              <span className={styles.headerTitleHighlight}>para tu transferencia.</span>
            </h2>
          </div>

          {/* Botón de acción */}
          <div className={styles.buttonContainer}>
            <button
              className="payment-button"
              onClick={processPayment}
              disabled={isSubmitting || isInvalidAmount}
            >
              <span className={styles.buttonText}>Obtener referencia</span>
              <img
                src={iconoBotonObtenerReferencia}
                alt="Icono obtener referencia"
                className={styles.buttonIcon}
              />
            </button>
          </div>

          <div className={styles.infoBox}>
            <p className={styles.infoText}>
              Para que tu transferencia se complete con éxito asegúrate de llenar correctamente la
              cuenta <strong>CLABE, referencia y concepto.</strong>
            </p>
          </div>

          <SpeiWarnings />
        </div>
      )}

      {order && (
        <div className={styles.orderInfo}>
          <div>¡Tu ficha de depósito se creo con éxito! </div>
          <div>Descarga el PDF y sigue las instrucciones para realizar la transferencia SPEI:</div>
          <div className="text-center">
            <img
              src={`https://api.openpay.mx/barcode/${order.payment_method.reference}?width=2&height=80&text=true`}
              className={`${styles.barcodeImage}`}
              alt="Código de barras"
            />
          </div>
          <div>Código de la ficha ${amount} MXN</div>

          <SpeiWarnings />

          <button
            className="payment-button"
            onClick={() => window.open(order.pdfUrl, '_blank')}
          >
            
            <span className={styles.buttonText}>Descarga tú ficha</span>

            <img
                src={iconoBotonObtenerReferencia}
                alt="Icono obtener referencia"
                className={styles.buttonIcon}
              />
          </button>
        </div>
      )}
    </div>
  );
};
